import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import close from "../assets/cancel.svg";
import user from "../assets/user.svg";
import { toast } from "react-toastify";
import { logout } from "../../actions/auth";

const ProfileMenu = ({ setOpen }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className="profile-menu">
      <span className="close">
        <img
          src={close}
          style={{ width: "1rem", height: "1rem" }}
          alt="close"
          onClick={() => {
            setOpen(false);
          }}
        />
      </span>
      <div className="user">
        <span>
          <img src={user} alt="user" />
        </span>
        <p>{localStorage.getItem("email")}</p>
        {/* <p>User ID: 2232309</p> */}
        {/* <p className="dim">{localStorage.getItem("email")}</p> */}
        <div className="flex-center logout">
          <button
              onClick={() => {
                setOpen(false);
            const email = localStorage.getItem("email");
            dispatch(logout({ email }));
            setTimeout(() => {
              localStorage.clear();
              toast.success("Successfully logged out");
              history.push("/admin/");
            }, 1000);
            }}
          >
            Logout
          </button>
        </div>
      </div>
      <br />
      {/* <h4>Profile</h4>
      <ul>
        <li>Settings</li>
        <li>User and Roles</li>
        <li>Change Password</li>
      </ul>
      <h4>Help and Support</h4>
      <ul>
        <li>Contact Us</li>
        <li>FAQs</li>
        <li>How to use</li>
      </ul>
      <h4>Terms of Use</h4>
      <ul>
        <li>Terms and Conditions</li>
      </ul> */}
    </div>
  );
};

export default ProfileMenu;
